<template>
  <div class="page-container">
    <div id="searchArea">
      <div class="clearfix">
        <div class="fl pb10">
          <el-button type="primary" @click="addOrUpdateHandle()">Add Template</el-button>
        </div>
        <div class="fr">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item>
              <el-input v-model="dataForm.title" placeholder="Title" clearable class="wd200"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="dataForm.subject" placeholder="Subject" clearable class="wd250"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div>
      <el-table
        max-height="680"
        v-loading="dataListLoading"
        :data="dataList"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column prop="title" align="center" label="Title" min-width="200" sortable="custom"></el-table-column>
        <el-table-column prop="subject" align="center" label="Subject" min-width="200"></el-table-column>
        <el-table-column prop="createTime" align="center" label="Create Time" width="180" sortable="custom"></el-table-column>
        <el-table-column prop="updateTime" align="center" label="Update Time" width="180"></el-table-column>
        <el-table-column label="Action" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 新建或修改 = 弹窗 -->
    <add-or-update-dialog ref="addOrUpdateDialog" :templateList="templateList" @update="update" />
  </div>
</template>

<script>
import AddOrUpdateDialog from "./modal/AddOrUpdate";
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
export default {
  mixins: [paginationMixin, tableMixin],
  components: {
    AddOrUpdateDialog,
    Pagination,
  },
  data() {
    return {
      dataForm: {
        title: "",
        subject: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      dataList: [],
      templateList: [],
      dataListLoading: false,
    };
  },
  methods: {
    // 获取营销邮件模版列表
    getTemplateList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/promoEmailTemplate/getList")
          .then(res => {
            this.templateList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/promoEmailTemplate/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this template. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/promoEmailTemplate/${row.id}/delete`, {});
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
            // 更新营销邮件模版列表
            this.getTemplateList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdateDialog.init(row);
    },
    // 更新
    update() {
      this.getDataList();
      // 更新营销邮件模版列表
      this.getTemplateList();
    },
  },
  async activated() {
    try {
      this.dataListLoading = true;
      await this.getTemplateList();
    } catch (error) {
    } finally {
      // 获取分页数据
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped></style>
